import BaseSyncError from "scripts/exceptions/baseSyncError";

class ForbiddenSyncError extends BaseSyncError {}

export default ForbiddenSyncError;
